/* eslint-disable */
import React from 'react';
import cls from 'classnames';
import {
  ToolbarLib,
  TOOL_TYPE,
  ToolContent,
  TMoreContent
} from '@syl-editor/lib/dist/lib/modules/toolbar';
import { IToolbarOutlineProps } from '../ToolbarOutline';
import { Popover } from '@byte-design/ui';
import { SylApi } from '@syl-editor/core-utilities';
import { renderSylButton, renderMoreToolButton } from '@syl-editor/react-syl-editor-v2/dist/lib/modules/toolbar/utils';
import './style.scss';
import {debounce} from 'lodash'

class ToolbarOutline extends React.Component<IToolbarOutlineProps, {}> {
  public toolbarLib: ToolbarLib;

  constructor(props: IToolbarOutlineProps) {
    super(props);
    this.toolbarLib = new ToolbarLib(props);
  }

  private format: any = {};

  public renderTool = (content: ToolContent, depth = 0) => {
    switch (content.type) {
      case TOOL_TYPE.MORE: {
        return renderMoreToolButton({
          editor: this.props.editor,
          option: this.props.option,
          content: content as TMoreContent,
          depth,
          toolbarType: 'outline',
          renderMenu: (tools :any, _depth: number) =>
            tools.map((tool: ToolContent) => this.renderTool(tool, _depth + 1))
        } as any);
      }
      default: {
        return renderSylButton({
          editor: this.props.editor,
          option: this.props.option,
          activeFormat: this.format,
          content,
          depth,
          toolbarType: 'outline',
        } as any);
      }
    }
  };

  private mouseMove = debounce((editor: SylApi, hover: boolean) =>{
    const dom = (window as any).EditorHoverDom;
    if(dom && dom.pmViewDesc && dom.pmViewDesc.node &&  hover){
      editor.removeShadow('outline');
      let style = 'background: #E1EBFF; border-radius: 4px; cursor: grab;';
      editor.appendShadow({
        index: dom.pmViewDesc.posBefore,
        length: dom.pmViewDesc.node.nodeSize,
        attrs: {
          style,
        },
        spec: { key: 'outline' },
      });
    }
  }, 0)

  private  getFormatObject(editor: SylApi, dom: any){
    if(dom && dom.pmViewDesc && dom.pmViewDesc.node){
      const rang = {index: dom.pmViewDesc.posBefore,length: dom.pmViewDesc.node.nodeSize}
      let mark: any = [];
      this.format = {};
      editor.nodesBetween((node: any, pos: any, parent: any): any =>{
        mark = Array.from(new Set(mark.concat(node.marks.map((item: any)=>{ return item.type.name })).concat(parent.type.name)))
      }, rang)

      mark.forEach((item: string)=>{
        if(item.indexOf('header')>-1){
          this.format[item] = { level: parseInt(item.replace('header','') || '1', 10) };
          return
        }
        this.format[item] = true;
      })
    }
  }

  private handler = (handler: any ,editor: SylApi, name: string, bool: boolean)=>{
    const dom = (window as any).EditorHoverDom;
    if(dom && dom.pmViewDesc){
      const index = dom.pmViewDesc.posBefore;
      const length = dom.pmViewDesc.node.nodeSize;
      if(handler){
        let rang = {index, length: 0}
        if(name === 'code_block'){
          rang = {index, length}
        }
        editor.setSelection(rang);

        return handler(editor)
      }
      editor.setFormat({ [name]: bool },{index, length })
      
      // block 元素切换时需要隐藏
      if(['header1','header2','header3','block_quote',
      'strike', 'bullet_list', 'ordered_list', 'hr'].indexOf(name)>- 1){
        editor.command.toolbarOutline.hide()
      }
      
    }
  }

  render() {
    const dom = (window as any).EditorHoverDom;
    const { contents } = this.toolbarLib;
    const { visible, editor } = this.props;
    const { className = '' } = this.props.option;
    // 判断是有 select toolbar
    const hover = editor.command.toolbarInline ? !editor.command.toolbarInline.getVisible() : true;
    // 重新构建toolbar
    this.getFormatObject(editor, dom);
    const createContent = contents.map((content: any)=>{
      const handler = this.handler.bind(this,  content.toolbar.handler)
      const toolbar = { ...content.toolbar, handler }
      return { ...content, toolbar }
    })
    let showTips = editor.command.toolbarOutline.getVisible();
    // 判断 logo 图标
    const isAdd = dom && dom.textContent === '';

    return (
      <>
        {showTips && <Popover
          trigger="click"
          placement="left-start"
          showDelay={100}
          hideDelay={0}
          onShow={()=>{
            (document.getElementById('syl-toolbar-outline-tool-icon')as HTMLDivElement)!.style.color = '#338aff';
          }}
          onHide={()=>{
            (document.getElementById('syl-toolbar-outline-tool-icon')as HTMLDivElement)!.style.color = '#555';
          }}
          offset={{x: 0, y: -10}}
          popoverClassName="syl-pop-toolbar"
          getPopper={() => {
            return (<div className="syl-toolbar-outline-container">
              <div
                className={cls('syl-toolbar-outline', {
                  [className]: className,
                  visible
                })}
                onClick={() => editor.focus()}
              >
                {createContent.map(content => this.renderTool(content))}
              </div>
            </div>)
          }}
          style={{ marginLeft: '10px', pointerEvents: hover ? 'auto' : 'none' }}
        >
          <span 
            id='syl-toolbar-outline-tool-icon'
            className={`tool-operation iconfont ${isAdd?'icon-add': 'icon-more'}`}
            onMouseEnter={()=>{this.mouseMove(editor,hover)}}
          />
        </Popover>}
      </>
    );
  }
}

export  { ToolbarOutline }